<template>
  <section class="get-quote">
    <v-container class="mx-auto">
      <v-row class="mt-10">
        <v-col cols="12" sm="6" lg="4" v-for="card in cards" :key="card.id">
          <v-card height="275" class="hover-card">
            <v-list-item>
              <v-list-item-content>
                <v-icon class="card-icon" x-large>
                  {{ card.icon }}
                </v-icon>
                <p class="card-title">
                  {{ card.title }}
                </p>
                <p class="card-description">
                  {{ card.desc }}
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      cards: [
        {
          id: 1,
          icon: 'fas fa-file-alt',
          title: 'Sigorta Sözlüğü',
          desc:
            'Sigortalılarımızı doğru şekilde bilgilendirmek için tasarlanan ve oluşturulan bu veri tabanı ile sigortanın gerçekte ne olduğunu ve diğer tüm terimleri en kısa haliyle kolayca öğrenebilirsiniz. Araştırma sürecinizi kolaylaştıracak ve detaylarla uyum içinde kalmanızı sağlamaya yardımcı olacaktır. '
        },
        {
          id: 2,
          icon: 'fas fa-tasks',
          title: 'Sigorta Türleri',
          desc:
            'Sigorta türlerinin ve amaçlarının kapsamlı listesini bu sayfada bulabilirsiniz. İhtiyaç duyabileceğiniz kapsam türü ve sizin için ne kadar mantıklı olduğu hakkında en doğru bilgiye ulaşmanız sözlük sayfasının amacıdır. '
        },
        {
          id: 3,
          icon: 'fas fa-clipboard-check',
          title: 'Sigorta Öğrenimi',
          desc:
            'Adım adım gözden geçirme ve öğrenme herkes için sigorta bilgisini tazeleme fırsatıdır. Bu bölüm, yeni umutların sektörü kapsamlı öğrenmesi için ihtiyaç duyacağı her şeyi içerir. Bu sayfada öğrenme / çalışma oyunları bulacaksınız.'
        }
      ]
    }
  }
}
</script>
<style scoped></style>
